import { Button, Input } from "@bigbinary/neeto-atoms";
import { Search as SearchIcon, X } from "lucide-react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const Search = ({ isCollapsed = true, onCollapse, ...props }) => {
  const { t } = useTranslation();

  if (isCollapsed) return null;

  return (
    <div className="mb-5 flex items-center gap-1">
      <div className="relative flex-grow">
        <SearchIcon className="text-muted-foreground absolute start-3 top-1/2 size-4 -translate-y-1/2" />
        <Input
          className="ps-9"
          placeholder={t("neetoMolecules.common.actions.search")}
          type="search"
          {...props}
        />
      </div>
      <Button
        data-testid="menubar-search-close-icon"
        size="icon-sm"
        variant="ghost"
        onClick={onCollapse}
      >
        <X size={16} />
      </Button>
    </div>
  );
};

Search.propTypes = {
  isCollapsed: PropTypes.bool,
  onCollapse: PropTypes.func,
};

export default Search;
